import { render, staticRenderFns } from "./ProjectsV4.vue?vue&type=template&id=1b741ba8&scoped=true"
import script from "./ProjectsV4.vue?vue&type=script&lang=js"
export * from "./ProjectsV4.vue?vue&type=script&lang=js"
import style0 from "./ProjectsV4.vue?vue&type=style&index=0&id=1b741ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b741ba8",
  null
  
)

export default component.exports